export default {
  loading: false,
  logisticProviders: [],
  deliveryMethod: {},
  overlapContract: {},
  activeLogisticProviders: [],
  logisticProvider: {},
  contractLogs: [],
  contracts: {
    currentContracts: [],
    draftContracts: [],
    historyContracts: [],
    contestedContracts: [],
    detailedContracts: [],
  },
  contractData: [],
};



// WEBPACK FOOTER //
// ./src/stores/logistic-providers/states.js